import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { MarketplaceAdditionalArgs } from './getPopularMarketplaceAssets';
import { GetPopularMarketplaceAssets } from './getTopTenMarketplaceAssets';

export type GetNewlyAddedMarketplaceAssetsResponse = {
  marketplaceAssets: DefaultApiResponse<GetPopularMarketplaceAssets[]>;
};
type GetNewlyAddedMarketplaceAssetsArgs = MarketplaceAdditionalArgs;

export const getNewlyAddedMarketplaceAssetsQuery: TypedDocumentNode<
  GetNewlyAddedMarketplaceAssetsResponse,
  DefaultArg & GetNewlyAddedMarketplaceAssetsArgs
> = gql`
  query GetNewlyAddedMarketplaceAssets(
    $record: MarketplaceAssetsListRecord!
    $changeRecord: AssetsRateChangeRecord!
    $rateRecord: AssetsRateChangeRecord!
  ) {
    marketplaceAssets: getNewlyAddedMarketplaceAssets(record: $record) {
      code
      isFavorite
      name
      iconUrl
      rate(record: $rateRecord)
      change(record: $changeRecord)
      marketCap
    }
  }
`;
